import ProjectsCoworkers from '@/components/ProjectsCoworkers/ProjectsCoworkers.vue';
import { ProjectType } from 'types';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DigitalizationProjectCoworkers',

  components: { ProjectsCoworkers },

  props: {
    digitalizationProjectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      projectCoworkersTableMode: ProjectType.DIGITALIZATION_PROJECT,
    };
  },
});
